import styled from "@emotion/styled";

// Manager container
export const ManagerContainer = styled.div`
  display: grid;
`;

export const H1 = styled.h1`
  margin-bottom: 1rem;
`;
export const Span = styled.span``;
